import { Card } from '@/components/ui/card';
import { Skeleton } from '../ui/skeleton';
import { AnimatedCounter } from './animated-counter';
import { useProfiles } from '@/api/profiles.api';
import useProfilesStore from '@/store/useProfilesStore';

const ReviewsCounterSkeleton = () => (
  <>
    <Skeleton className="h-6 w-[60px] lg:w-[180px]" />
    <div className="hidden flex flex-col items-start gap-2 lg:flex">
      <Skeleton className="h-14 w-[50px]" />
      <Skeleton className="h-2 w-[200px]" />
    </div>
  </>
);

const ReviewsCounter = () => {
  const { data, error, isLoading } = useProfiles();

  const { profiles, reviewed } = useProfilesStore();

  const pendingReviews = data ? data.total - reviewed : 0;

  if (!profiles || error) {
    return null;
  }

  return (
    <Card className="flex flex-col-reverse items-start gap-0.5 p-0 shadow-none border-none lg:flex-col lg:gap-3 lg:p-6 lg:border-solid lg:border-border lg:rounded-lg lg:drop-shadow-sm">
      {isLoading ? (
        <ReviewsCounterSkeleton />
      ) : (
        <>
          <h2 className="text-xs text-foreground leading-none font-light lg:font-normal lg:text-xl lg:leading-none">
            Pending Reviews
          </h2>
          <div className="flex flex-col items-start gap-0.5 lg:gap-1.5">
            {isLoading ? (
              <>
                <Skeleton className="h-14 w-[50px]" />
                <Skeleton className="h-2 w-[200px]" />
              </>
            ) : (
              <>
                <AnimatedCounter value={pendingReviews} />
                {reviewed ? (
                  <span className="hidden text-xs text-muted-foreground leading-none font-light lg:block">
                    You've completed {reviewed} reviews
                  </span>
                ) : null}
              </>
            )}
          </div>
        </>
      )}
    </Card>
  );
};

export { ReviewsCounter };
